import React from "react";
import loadable from "@loadable/component";
import CenterSpinner from "../../common/centerSpinner";

function AsyncRolesSetup({ ...rest }) {
  const AsyncLoad = loadable(() => import("../page/rolesDashboard"));
  console.log("Loading", AsyncRolesSetup.name);
  return <AsyncLoad {...rest} fallback={<CenterSpinner />} />;
}

export default AsyncRolesSetup;
